import getLocal from '@/app/utils/getLocal';
import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { tcLang } from './lang';

export default function Comp({ pageType }: { pageType?: 'ac' | 'ultra' }) {
    const { locale } = getLocal();
    const tcLanguage = tcLang[locale] || tcLang['eu'];

    const items: EcoTextTcItemProps[] = [
        {
            isHead: true,
            title: tcLanguage.head1,
        },
        {
            title: tcLanguage.titleA2,
            desc: tcLanguage.descA2,
            isOpen: true,
        },
        {
            title: tcLanguage.titleA3,
            desc: tcLanguage.descA3,
        },
    ];

    return (
        <div
            id="stream-ultra-x-FooterTcA"
            className="GtmModuleData-section"
            data-section-id={'stream-ultra-x-FooterTcA '}
            data-section-title={tcLanguage.head1}
        >
            <EcoTextTc items={items} className={styles.comp} theme="black" />
        </div>
    );
}
